/**
 * The design preview: the fixture prototype under `/prototype`. Its session
 * state lives here, so nothing outside this subtree sees fixture data.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { PrototypeProvider } from "../prototype/store";

export const Route = createFileRoute("/prototype")({
  component: () => (
    <PrototypeProvider>
      <Outlet />
    </PrototypeProvider>
  ),
});
